module.exports = " <div _v-84612aba=\"\"> count is {{ counterVaule }} </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-84612aba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Display.vue
 ** module id = 16
 ** module chunks = 1
 **/